import Accordion from './Accordion';
import AccordionPanel from './AccordionPanel';

// export types
export type { AccordionProps } from './Accordion';
export type { AccordionPanelProps } from './AccordionPanel';

// export components
export { Accordion, AccordionPanel };
export default Accordion;
